module.exports = __webpack_public_path__ + "static/scale-model-of-minnie's-house-in-fullerton-california-f8d391694b1ab874b7d605e1ca030b92.png";